import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonFI from "./locales/fi/common.json";
import commonPL from "./locales/pl/common.json";
import commonEN from "./locales/en/common.json";
import commonDA from "./locales/da/common.json";
import commonNO from "./locales/no/common.json";
import commonSV from "./locales/sv/common.json";
import commonNL_NL from "./locales/nl-NL/common.json";
import commonNL_BE from "./locales/nl-BE/common.json";
import commonFR_BE from "./locales/fr-BE/common.json";

const resources = {
  "fi": { common: commonFI },
  "pl": { common: commonPL },
  "en": { common: commonEN },
  "da": { common: commonDA },
  "no": { common: commonNO },
  "sv": { common: commonSV },
  "nl-NL": { common: commonNL_NL },
  "nl-BE": { common: commonNL_BE },
  "fr-BE": { common: commonFR_BE },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    supportedLngs: ["en", "fi", "pl", "da", "no", "sv", "nl-NL", "nl-BE", "fr-BE"],

    fallbackLng: "en",

    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag", "path", "subdomain"],
      caches: ["cookie", "localStorage"],
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",
    },

    debug: false,

    interpolation: {
      escapeValue: false,
    },
  });

const t = i18n.t.bind(i18n);
const tIfExists = (v) => (i18n.exists(v) ? t(v) : null);

export default i18n;
export { t, tIfExists };
